import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';
import { SVGAnimation } from 'components/SVGAnimation';

import success from 'assets/animations/success.json';

export function TeamChangeRequested() {
  const { t } = useLang();

  return (
    <Column alignItems="center" gap="2">
      <SVGAnimation size={120} animationData={success} />

      <h6>{t('team-change-requested')}</h6>

      <p>{t('please-wait-until-your-request-is-validated')}</p>
    </Column>
  );
}
